import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchSplitter: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.splitters.getByUUID(
        uuid,
        result => {
          let splitter = result.data.data;
          resolve(splitter);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createSplitter: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.splitters.create(
        data,
        result => {
          let splitter = result.data.data;
          resolve(splitter);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateSplitter: ({ commit }, updatedSplitter) => {
    return new Promise((resolve, reject) => {
      API.splitters.edit(
        updatedSplitter,
        result => {
          let splitter = result.data.data;
          resolve(splitter);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteSplitter: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.splitters.delete(
        uuid,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchSplittersInObject: ({ commit }, { objectEndpoint, objectUUID }) => {
    return new Promise((resolve, reject) => {
      API.splitters.getSplittersInObject(
        objectEndpoint,
        objectUUID,
        result => {
          let splitters = result.data.data;
          resolve(splitters);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchCablesInObject: (
    { commit },
    { objectEndpoint, objectUUID, cableType }
  ) => {
    return new Promise((resolve, reject) => {
      API.splitters.getObjectCables(
        objectEndpoint,
        objectUUID,
        cableType,
        result => {
          let splitters = result.data.data;
          resolve(splitters);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchCablesInAndOut: (
    { commit },
    { endpoint, objectUUID }
  ) => {
    return new Promise((resolve, reject) => {
      API.splitters.getAllCables(
        endpoint,
        objectUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createPortConnection: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.splitters.createConnection(
        data,
        result => {
          let splitter = result.data.data;
          resolve(splitter);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updatePortConnection: ({ commit }, { uuid, data }) => {
    return new Promise((resolve, reject) => {
      API.splitters.editConnection(
        uuid,
        data,
        result => {
          let splitter = result.data.data;
          resolve(splitter);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deletePortConnection: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.splitters.deleteConnection(
        uuid,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/splitters.js